<div
    infiniteScroll
    [infiniteScrollContainer]="scrollablePane"
    [infiniteScrollDistance]="3"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false"
    [immediateCheck]="true"
    [infiniteScrollDisabled]="loading"
    [alwaysCallback]="true"
    (scrolled)="onScroll()"
    class="src-scroll-container"
>
    <!-- Loading Indicator -->
    <div *ngIf="loading" class="src-product-cards-container">
        <div
            class="src-product-card-wrapper"
            *ngFor="let item of [].constructor(10)"
        >
            <md-product-card-loading></md-product-card-loading>
        </div>
    </div>
    <div class="err-box">
        <div
            *ngIf="errorMessage"
            class="src-error-message"
            [innerHtml]="errorMessage"
        ></div>
        <div
            *ngIf="errorContact"
            class="src-error-contact"
            [innerHtml]="errorContact"
        ></div>
        <!-- Search Results -->
        <div class="no-results" *ngIf="!loading"></div>
    </div>
    <div *ngIf="deals.length > 0" class="src-product-cards-container">
        <div
            class="src-product-card-wrapper"
            *ngFor="let deal of deals"
            (click)="redirectToProductDetails(deal)"
        >
            <md-product-card
                [dealEntry]="deal"
                (dealSelected)="redirectToProductDetails(deal)"
            ></md-product-card>
        </div>
    </div>
</div>
